import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Curtain } from "@/components/site/Curtain";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import CaseStudy from "@/pages/CaseStudy";

const LABELS = { "/": "Skaris", "/about": "About", "/services": "Services", "/contact": "Contact" };

const Shell = () => {
  const { pathname } = useLocation();
  return (
    <>
      <SmoothScroll />
      <Nav />
      <Curtain key={pathname} label={LABELS[pathname] || (pathname.startsWith("/work") ? "Case study" : "Skaris")} />
      <div key={`p-${pathname}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/work/:slug" element={<CaseStudy />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      <Footer />
      <div className="grain pointer-events-none fixed inset-0 z-[90]" />
    </>
  );
};

function App() {
  return (
    <div className="App bg-skaris-ink">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
